var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProhibit = function SvgIconProhibit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.979 4.88a1 1 0 0 0-.099.098A9.97 9.97 0 0 0 2 12c0 5.523 4.477 10 10 10a9.97 9.97 0 0 0 7.017-2.876 1 1 0 0 0 .108-.107A9.97 9.97 0 0 0 22 12c0-5.523-4.477-10-10-10a9.97 9.97 0 0 0-7.021 2.88m2.116.8A8 8 0 0 1 18.32 16.905zm9.81 12.64A8 8 0 0 1 5.68 7.094z",
    clipRule: "evenodd"
  })));
};
export default SvgIconProhibit;